module.exports = __webpack_public_path__ + "files/cb88bc6d4f4b2a3f7ed4a982c5f46376.png";